import { render, staticRenderFns } from "./SolvedManage.vue?vue&type=template&id=2714cb78&scoped=true&"
import script from "./SolvedManage.vue?vue&type=script&lang=js&"
export * from "./SolvedManage.vue?vue&type=script&lang=js&"
import style0 from "./SolvedManage.vue?vue&type=style&index=0&id=2714cb78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2714cb78",
  null
  
)

export default component.exports